<template>
    <!--红包样式-->
    <div class="contain">
        <div class="packetBox boxSizing" :class="packCss[item.status]" v-for="item in myPacket" @click="choosedPack(item.price,item.id)">
            <div class="packTop clearfix">
                <div class="packFl fl">
                    <div class="packPrice">￥<span v-text="item.price"></span></div>
                    <div class="packTotal">满<span v-text="item.small_price"></span>可用</div>
                </div>
                <div class="packMid fl">
                    <div class="packMidTop oneEllipsis" v-text="item.rb_name"></div>
                    <div><span v-text="item.begin_time"></span> - <span v-text="item.end_time"></span></div>
                </div>
                <router-link class="packState fr" v-if="item.status === 1 && item.stabtn" :to="{path:'/'}">去使用</router-link>
            </div>
            <div class="packetBot oneEllipsis" v-text="item.info">仅可购买财经专业下沃米商城指定产品，下单时自动抵扣</div>
        </div>
    </div>
</template>

<script>
    import axios from "axios";
    import qs from "qs";
    import moment from "moment/moment.js";
    export default {
        name: "packet",
        data() {
            return {
                // price: "",
                // begin_time: "",
                // end_time: "",
                // info: "",
                // rb_name: "",
                // small_price: "",
                // status: 1,
                // iftimeout: false,
                packCss: {
                    1: 'timein',
                    2: 'used',
                    3: 'timeout'
                }
            }
        },
        mounted() {
            // this.getMypacket();
        },
        methods: {
            //点击红包，选择使用该红包  给父组件传值
            choosedPack:function (price,id) {
                this.$emit('childChoosed',price,id);
            }
            // getMypacket:function() {
            //     axios
            //         .post(
            //             "/wap/RedBagShow/redBagList",
            //             qs.stringify({
            //                 page: 1,
            //             })
            //         )
            //         .then(data => {
            //             console.log(data);
            //             var data = data.data.data;
            //             for (var i = 0; i < data.length; i++) {
            //                 var obj={};
            //                 obj.price = data[i].price;
            //                 obj.begin_time = moment(data[i].begin_time).format('YYYY.MM.DD');
            //                 obj.end_time = moment(data[i].end_time).format('YYYY.MM.DD');
            //                 obj.info = data[i].info;
            //                 obj.rb_name = data[i].rb_name;
            //                 obj.small_price = data[i].small_price;
            //                 obj.status = data[i].status;
            //                 this.myPacket.push(obj);
            //                // 判断是否过期,是否使用
            //                //  var today = (new Date()).getTime();//today是当前日期的时间戳
            //                //  if (data[i].end_time - today > 0) {
            //                //      // console.log(today - data[i].end_time);
            //                //      this.iftimeout = true;
            //                //  }else{
            //                //      this.iftimeout = false;
            //                //  }
            //             }
            //         })
            //         ["catch"](error => {
            //         console.log(error);
            //     });
            // }
        },
        props:['myPacket']
    };
</script>

<style scoped lang="scss">
    .contain{
        font-size: 24px;
        color: #999;
    }
    .packetBox{
        width: 100%;
        height: 230px;
        padding: 38px 20px 30px 30px;
        margin-bottom: 30px;
    }
    .packTop{
        .packFl{
            text-align: center;
            margin-right: 40px;
            color: #FF8004;
        }
        .packPrice{
            font-size: 50px;
        }
        .packMid{
            width: 290px;
        }
        .packMidTop{
            margin: 4px 0 20px;
            font-size: 32px;
            color: #666;
        }
        .packState{
            display: block;
            width: 150px;
            height: 50px;
            line-height: 50px;
            border-radius: 30px;
            text-align: center;
            margin-top: 16px;
            color: #fff;
            background: #FF8004;
        }
    }
    .timein{
        background: url("../../assets/touse.png") no-repeat;
        background-size: 100%;
    }
    .timeout,.used{
        background: url("../../assets/timeout.png") no-repeat;
        background-size: 100%;
        color: #CFCFCF;
        .packTop{
            .packFl{
                color: #CFCFCF;
            }
        }
        .packMidTop{
            color: #CFCFCF;
        }
    }
    .used{
        background: url("../../assets/used.png") no-repeat;
        background-size: 100%;
    }
    .packetBot{
        margin-top: 30px;
        font-size: 22px;
    }
</style>
